import { createTypes } from "@/store/utils";

export const LOGIN = createTypes("LOGIN");
export const LOGOUT = createTypes("LOGOUT");
export const SIGNUP = createTypes("SIGNUP");
export const PASSWORD_RESET_INIT = createTypes("PASSWORD_RESET_INIT");
export const PASSWORD_RESET_FINISH = createTypes("PASSWORD_RESET_FINISH");
export const CHANGE_PASSWORD = createTypes("CHANGE_PASSWORD");
export const SEND_ONBOARDING_EMAIL = createTypes("SEND_ONBOARDING_EMAIL");
